import "./headquartersPageStyles.scss";

import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { GOOGLE_MAPS_API_KEY } from "../../../../../config/env";

function HeadquartersComponent({
    reverse,
    title,
    secondTitle,
    content,
    located,
    image = "/assets/headquaters/sede-1.svg",
}) {
    const mapContainerStyle = {
        width: "98%",
        height: "180px",
    };

    const location1 = {
        lat: 4.691959880308249,
        lng: -74.07611493603319,
    };
    const center = {
        lat: location1.lat,
        lng: location1.lng,
    };
    return (
        <div
            style={{
                backgroundColor: !reverse ? "white" : "#1e1e1e",
                position: "relative",
                zIndex: 0,
                display: "flex",
                flexDirection: reverse ? "row" : "row-reverse",
            }}
        >
            <img
                src="./assets/home/lines_2.svg"
                alt="sedes"
                title="sedes"
                style={{ position: "absolute", right: 10, bottom: 10, zIndex: "0" }}
                loading="lazy"
                decoding="async"
            />
            <img src={image} alt="" className="img-car" style={{ height: "110%" }} />
            <div
                style={{
                    marginTop: 0,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                }}
            >
                <div className=" m-auto p-4">
                    <div className="d-flex align-items-center pb-1">
                        <div
                            className="me-2"
                            style={{
                                width: "48px",
                                height: "1px",
                                background: "#00FEFE",
                            }}
                        ></div>
                    </div>
                    <h4 style={{ fontSize: 36, color: reverse ? "white" : "#1e1e1e", marginBottom: 20 }}>
                        {title} <i className="text_orange">{secondTitle}</i>
                    </h4>

                    <div className="" style={{ gap: 10, marginTop: 20 }}>
                        <div>
                            <p
                                style={{
                                    fontSize: 16,
                                    color: reverse ? "white" : "#1e1e1e",
                                    marginTop: 10,
                                    maxWidth: 584,
                                    width: "100%",
                                }}
                            >
                                {content}
                            </p>
                        </div>
                        <div className="d-flex" style={{ gap: 20, marginTop: 20 }}>
                            <div style={{ width: "50%" }}>
                                <div className="d-flex align-items-center pb-1">
                                    <div
                                        className="me-2"
                                        style={{
                                            width: "48px",
                                            height: "1px",
                                            background: "#00FEFE",
                                        }}
                                    ></div>
                                    <strong
                                        style={{
                                            color: reverse ? "white" : "#1e1e1e",
                                        }}
                                    >
                                        Ubicación
                                    </strong>
                                </div>
                                <div
                                    style={{
                                        color: reverse ? "white" : "#1e1e1e",
                                    }}
                                >
                                    {located}, Bogotá, Colombia
                                </div>
                            </div>
                            {/* <div style={{ width: "50%" }}>
                                <div className="d-flex align-items-center pb-1">
                                    <div
                                        className="me-2"
                                        style={{
                                            width: "48px",
                                            height: "1px",
                                            background: "#00FEFE",
                                        }}
                                    ></div>
                                    <strong
                                        style={{
                                            color: reverse ? "white" : "#1e1e1e",
                                        }}
                                    >
                                        Horario
                                    </strong>
                                </div>
                                <div
                                    style={{
                                        color: reverse ? "white" : "#1e1e1e",
                                    }}
                                >
                                    Lunes a Sabado de 9 a.m. - 6p.m.
                                </div>
                            </div> */}
                        </div>
                        <div className="container-map-desk" style={{ marginTop: 50 }}>
                            <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
                                <GoogleMap mapContainerStyle={mapContainerStyle} center={center} zoom={9}>
                                    <Marker position={location1} />
                                </GoogleMap>
                            </LoadScript>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HeadquartersComponent;
